import { Property } from "../../models/Property";
import { a } from "../utils";
import {PropertyAccessibilityInfo} from "../../models/PropertyAccessibilityInfo";
import {PropertyFreeTextsInfo} from "../../models/PropertyFreeTextInfos";



export const fetchProperty = (property: Property) => a({
    type: "FETCH_PROPERTY", property
});

export const fetchProperties = (properties: Property[]) => a({
    type: "FETCH_PROPERTIES", properties
})

export const setPropertyCount = (count: number) => a({
    type: "SET_PROPERTY_COUNT",
    count
})
export const createProperty = (property: Property) => a({
    type: "PROPERTY_CREATE",
    property
})

export const updateProperty = (property: Property) => a({
    type: "PROPERTY_UPDATE",
    property
})

export const partialUpdateProperty = (property: Property) => a({
    type: "PARTIAL_PROPERTY_UPDATE",
    property
})

export const getA11yUnitTypes = () => a({
    type: "GET_ACCESSIBILITY_UNIT_TYPES",
})

export const clearProperty = () => a({
    type:"CLEAR_PROPERTY"
})

export const clearProperties = () => a({
    type:"CLEAR_PROPERTIES"
})
export const fetchTotalAccessibilityProgressBar = (total: {completed: number, notCompleted: number}) => a({
    type:"FETCH_TOTAL_ACCESSIBILITY_PROGRESS_BAR",
    payload: total
})

export const clearTotalAccessibilityProgressBar = () => a({
    type:"CLEAR_TOTAL_ACCESSIBILITY_PROGRESS_BAR",
})

export const loadingProperty = (payload: boolean) => a({
    type:"LOADING_PROPERTY",
    payload: payload
})

export const loadingProperties = (payload: boolean) => a({
    type:"LOADING_PROPERTIES",
    payload: payload
})

export const fetchPropertyAccessibilityInfo = (propertyAccessibilityInfo: PropertyAccessibilityInfo[]) => a({
    type: "FETCH_PROPERTY_ACCESSIBILITY_INFOS", payload: propertyAccessibilityInfo
});

export const clearPropertyAccessibilityInfo = () => a({
    type: "CLEAR_PROPERTY_ACCESSIBILITY_INFOS"
});

export const updatePropertyAccessibilityInfo = (propertyAccessibilityInfo: PropertyAccessibilityInfo) => a({
    type: "UPDATE_PROPERTY_ACCESSIBILITY_INFOS", payload: propertyAccessibilityInfo
});

export const createPropertyAccessibilityInfo = (propertyAccessibilityInfo: PropertyAccessibilityInfo) => a({
    type: "CREATE_PROPERTY_ACCESSIBILITY_INFOS", payload: propertyAccessibilityInfo
});

export const fetchPropertyFreeTextInfos = (propertyFreeTextsInfos: PropertyFreeTextsInfo[]) => a({
    type: "FETCH_PROPERTY_FREE_TEXT_INFOS", payload: propertyFreeTextsInfos
});

export const clearPropertyFreeTextInfos = () => a({
    type: "CLEAR_PROPERTY_FREE_TEXT_INFOS"
});

export const createPropertyFreeTextInfos = (propertyFreeTextsInfo: PropertyFreeTextsInfo) => a({
    type: "CREATE_PROPERTY_FREE_TEXT_INFOS", payload: propertyFreeTextsInfo
});

export const updatePropertyFreeTextInfos = (propertyFreeTextsInfo: PropertyFreeTextsInfo) => a({
    type: "UPDATE_PROPERTY_FREE_TEXT_INFOS", payload: propertyFreeTextsInfo
});


export const deletePropertyFreeTextInfos = (id: string) => a({
    type: "DELETE_PROPERTY_FREE_TEXT_INFOS", payload: id
});
